// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2I62d","content":"Consent_content__mzCii","footer":"Consent_footer__3eNSQ"};